import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { MultiSelectionInput } from "colbi_web_ui/lib/components/inputs";
import defaultStyles from "./PackageDropdownMultiSelector.module.sass";

const PackageDropdownMultiSelector = ({
   selectedPackages,
   packages,
   handleChange,
   entitieID,
   styles,
   containerTitle,
   entitieKey,
}) => {
    const selectedStyles = styles ? styles : defaultStyles;
    const { i18n } = useGlobalValue();
    const items = packages || [];
    const valuesSelected =
        selectedPackages && selectedPackages.length
            ? selectedPackages.map((item) => item.packageId)
            : [];

    return (
      <div className={selectedStyles["package-container"]}>
        <h5 className={selectedStyles["input-label"]}>{i18n`${containerTitle}`}</h5>
        {packages && packages.length ?
          <MultiSelectionInput
          value={valuesSelected}
          options={items || []}
          className={selectedStyles["dropdown"]}
          placeholder={i18n`select package`}
          required
          filter
          onChange={(e) => {
            const packagesUpdated = e.target.value.map((itemId) => {
              const _package = { packageId: itemId };
              _package[entitieKey] = +entitieID;

              return _package;
            });

            handleChange(e, "Packages", packagesUpdated);
          }}
        /> :
          <small>{i18n`No packages available`}</small>
        }
      </div>
    );
};

export default PackageDropdownMultiSelector;
